import React from 'react';

const PlayerForm = ({ initialData = {}, onSubmit, isSubmitting = false }) => {
    const isOrganizer = initialData.role === 'organizer';

    const [formData, setFormData] = React.useState({
        firstName: initialData.firstName || '',
        lastName: initialData.lastName || '',
        email: initialData.email || '',
        phone: initialData.phone || '',
        gender: initialData.gender || '',
        level: initialData.level || '',
        laterality: initialData.laterality || '',
        position: initialData.position || '',
        brandName: initialData.brandName || '', // Campo para organizadores
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            {/* Sección: Datos Personales */}
            <div className={`p-4 rounded-xl space-y-4 transition-colors ${isOrganizer ? 'bg-indigo-50/50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-900/30' : 'bg-gray-50 dark:bg-slate-700/30 border border-transparent dark:border-slate-600'}`}>
                <h3 className={`text-sm font-bold uppercase tracking-wider flex items-center gap-2 ${isOrganizer ? 'text-indigo-700 dark:text-indigo-300' : 'text-gray-700 dark:text-gray-300'}`}>
                    <div className={`w-1.5 h-4 rounded-full ${isOrganizer ? 'bg-indigo-500' : 'bg-blue-500'}`}></div>
                    {isOrganizer ? 'Datos de la Organización' : 'Datos Personales'}
                </h3>
                
                {isOrganizer && (
                    <div className="mb-4">
                        <label className="block text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase mb-1 ml-1">Marca Comercial (Nombre del Club/Organización)</label>
                        <input
                            type="text"
                            name="brandName"
                            value={formData.brandName}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all text-sm outline-none font-bold text-gray-800 dark:text-white dark:placeholder-gray-500"
                            placeholder="Ej: Padel Pro Madrid"
                        />
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase mb-1 ml-1">Nombre</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm outline-none dark:text-white dark:placeholder-gray-500"
                            placeholder="Ej: Juan"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase mb-1 ml-1">Apellidos</label>
                        <input
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm outline-none dark:text-white dark:placeholder-gray-500"
                            placeholder="Ej: Pérez"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase mb-1 ml-1">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-slate-600 bg-gray-100 dark:bg-slate-900 text-gray-500 dark:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm outline-none cursor-not-allowed"
                            readOnly
                            title="El email no se puede cambiar"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase mb-1 ml-1">Teléfono</label>
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm outline-none dark:text-white dark:placeholder-gray-500"
                            placeholder="+34 600 000 000"
                        />
                    </div>
                </div>

                {!isOrganizer && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase mb-1 ml-1">Género</label>
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm outline-none appearance-none cursor-pointer dark:text-white"
                            >
                                <option value="">Seleccionar género...</option>
                                <option value="male">Hombre</option>
                                <option value="female">Mujer</option>
                                <option value="other">Prefiero no decirlo</option>
                            </select>
                        </div>
                        <div className="md:col-span-1">
                            <div className="flex justify-between items-center mb-1 ml-1">
                                <label className="block text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase">Nivel (Padel)</label>
                                <span className={`px-2 py-0.5 rounded-lg text-[10px] font-black border ${
                                    (formData.level || 0.5) < 2 ? 'bg-emerald-50 text-emerald-600 border-emerald-100' :
                                    (formData.level || 0.5) < 4 ? 'bg-blue-50 text-blue-600 border-blue-100' :
                                    (formData.level || 0.5) < 6 ? 'bg-amber-50 text-amber-600 border-amber-100' :
                                    'bg-red-50 text-red-600 border-red-100'
                                }`}>
                                    {parseFloat(formData.level || 0.5).toFixed(1)}
                                </span>
                            </div>
                            <div className="relative pt-2 px-1">
                                <input
                                    type="range"
                                    name="level"
                                    min="0.5"
                                    max="7.0"
                                    step="0.1"
                                    value={formData.level || 0.5}
                                    onChange={(e) => setFormData(p => ({ ...p, level: parseFloat(e.target.value) }))}
                                    className="w-full h-3 sm:h-2 bg-gray-200 dark:bg-slate-600 rounded-lg appearance-none cursor-pointer accent-primary-600 input-range-thumb"
                                />
                                <div className="flex justify-between mt-2 px-1">
                                    <span className="text-[10px] font-bold text-gray-400">0.5</span>
                                    <span className="text-[10px] font-bold text-gray-400">7.0</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Sección: Preferencias de Jugador (Solo si NO es organizador) */}
            {!isOrganizer && (
                <div className="bg-blue-50/30 dark:bg-blue-900/10 p-4 rounded-xl border border-blue-100/50 dark:border-blue-900/20 space-y-4 transition-colors">
                    <h3 className="text-sm font-bold text-blue-700 dark:text-blue-300 uppercase tracking-wider flex items-center gap-2">
                        <div className="w-1.5 h-4 bg-blue-600 rounded-full"></div>
                        Preferencias del jugador@
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Lateralidad */}
                        <div>
                            <label className="block text-[10px] font-bold text-blue-500/70 dark:text-blue-300/70 uppercase mb-3 ml-1 tracking-widest">Lateralidad</label>
                            <div className="flex flex-wrap gap-2 sm:gap-3">
                                {[
                                    { id: 'right', label: 'Diestro' },
                                    { id: 'left', label: 'Zurdo' },
                                    { id: 'ambidextrous', label: 'Ambidiestro' }
                                ].map((lat) => (
                                    <label key={lat.id} className="cursor-pointer flex-1 min-w-[100px] sm:flex-none">
                                        <input
                                            type="radio"
                                            name="laterality"
                                            value={lat.id}
                                            checked={formData.laterality === lat.id}
                                            onChange={handleChange}
                                            className="hidden"
                                        />
                                        <div className={`px-4 py-3 sm:py-2 rounded-xl text-xs font-black transition-all border-2 text-center ${
                                            formData.laterality === lat.id 
                                            ? 'bg-blue-600 border-blue-600 text-white shadow-lg shadow-blue-500/30' 
                                            : 'bg-white dark:bg-slate-800 border-gray-100 dark:border-slate-600 text-gray-400 dark:text-gray-500 hover:border-blue-200 dark:hover:border-blue-500/50'
                                        }`}>
                                            {lat.label}
                                        </div>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Posición */}
                        <div>
                            <label className="block text-[10px] font-bold text-blue-500/70 dark:text-blue-300/70 uppercase mb-3 ml-1 tracking-widest">Posición en pista</label>
                            <div className="flex flex-wrap gap-2 sm:gap-3">
                                {[
                                    { id: 'drive', label: 'Drive' },
                                    { id: 'reves', label: 'Revés' },
                                    { id: 'both', label: 'Ambos' }
                                ].map((pos) => (
                                    <label key={pos.id} className="cursor-pointer flex-1 min-w-[100px] sm:flex-none">
                                        <input
                                            type="radio"
                                            name="position"
                                            value={pos.id}
                                            checked={formData.position === pos.id}
                                            onChange={handleChange}
                                            className="hidden"
                                        />
                                        <div className={`px-4 py-3 sm:py-2 rounded-xl text-xs font-black transition-all border-2 text-center ${
                                            formData.position === pos.id 
                                            ? 'bg-blue-600 border-blue-600 text-white shadow-lg shadow-blue-500/30' 
                                            : 'bg-white dark:bg-slate-800 border-gray-100 dark:border-slate-600 text-gray-400 dark:text-gray-500 hover:border-blue-200 dark:hover:border-blue-500/50'
                                        }`}>
                                            {pos.label}
                                        </div>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="flex justify-end pt-2">
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-black py-3 px-10 rounded-xl transition-all shadow-xl shadow-blue-500/30 disabled:opacity-50 flex items-center justify-center gap-3 uppercase italic text-sm tracking-widest"
                >
                    {isSubmitting ? (
                        <>
                            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                            Procesando...
                        </>
                    ) : (
                        <>
                            <span>💾</span>
                            Guardar Ficha
                        </>
                    )}
                </button>
            </div>
        </form>
    );
};

export default PlayerForm;
